const cheese = [
  "Fresh Unripened Cheese",
  "White Mould Cheese",
  "Semi Hard/Eye Cheese",
  "Cheddar Cheese",
  "Hard Cheese",
  "Blue Cheese",
  "Gum Smoked Semi Hard Cheese",
  "Washed Rind/Mixed Rind Cheese",
  "Goat's Cheese",
  "Buffalo Milk Cheese"
]
export default cheese;